import { render, staticRenderFns } from "./ProfilePanel.vue?vue&type=template&id=6d2dafed&scoped=true&"
import script from "./ProfilePanel.vue?vue&type=script&lang=js&"
export * from "./ProfilePanel.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePanel.vue?vue&type=style&index=0&id=6d2dafed&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2dafed",
  null
  
)

export default component.exports